import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ChevronLeft, Plus, Trash2 } from 'lucide-react';
import { useFolders } from '../../hooks/useFolders';
import { useStops } from '../../hooks/useStops';
import { getFolderById } from '../../utils/localStorage';
import { ButtonPanel } from '../ButtonPanel';

export const FolderDetailScreen = () => {
  const navigate = useNavigate();
  const { folderId } = useParams();
  const { removeFolder } = useFolders();
  const { stops, removeStop } = useStops(folderId);

  const folder = getFolderById(folderId);

  if (!folder) {
    return (
      <div className="min-h-screen bg-gray-50 p-4 md:p-6 flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-500 text-lg">Carpeta no encontrada</p>
          <button
            onClick={() => navigate('/folders')}
            className="mt-4 px-6 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition font-semibold"
          >
            Volver
          </button>
        </div>
      </div>
    );
  }

  const manejarEliminarCarpeta = () => {
    if (window.confirm('¿Estás seguro de que deseas eliminar esta carpeta y todas sus paradas?')) {
      removeFolder(folderId);
      navigate('/folders');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <button
            onClick={() => navigate('/folders')}
            className="p-2 hover:bg-gray-200 rounded-lg transition"
          >
            <ChevronLeft className="text-gray-700" size={24} />
          </button>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{folder.name}</h1>
            <p className="text-sm text-gray-500">{stops.length} parada{stops.length !== 1 ? 's' : ''}</p>
          </div>
        </div>
        <button
          onClick={manejarEliminarCarpeta}
          className="p-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition"
        >
          <Trash2 size={20} />
        </button>
      </div>

      {/* Stops List */}
      <div className="grid gap-4 mb-6">
        {stops.length === 0 ? (
          <div className="text-center py-12 bg-white rounded-lg">
            <p className="text-gray-500 text-lg">No hay paradas en esta carpeta</p>
            <p className="text-gray-400 text-sm mt-2">Agrega tu primera parada</p>
          </div>
        ) : (
          stops.map((stop) => (
            <div key={stop.id} className="flex items-center gap-2">
              <ButtonPanel
                onClick={() => navigate(`/stop/${stop.stopId}`, { state: { stop } })}
                title={stop.stopName}
                subtitle={`Parada: ${stop.stopId}`}
                color={folder.color}
                className="flex-1"
                leftIcon="🚌"
              />
              <button
                onClick={() => {
                  if (window.confirm('¿Eliminar esta parada?')) {
                    removeStop(stop.id);
                  }
                }}
                className="p-2 bg-red-500 hover:bg-red-600 text-white rounded-lg transition"
              >
                <Trash2 size={18} />
              </button>
            </div>
          ))
        )}
      </div>

      {/* Add Stop Button */}
      <button
        onClick={() => navigate(`/folder/${folderId}/add-stop`)}
        className="w-full p-4 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition font-semibold flex items-center justify-center gap-2"
      >
        <Plus size={20} />
        Agregar Parada
      </button>
    </div>
  );
};
